import { Component } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { MainButtonComponent } from '../../buttons/main-button/main-button.component';
import { Store } from '@ngrx/store';
import { ModalsActions } from 'src/app/core/store/modals/actions/modals.actions';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-require-profile-modal',
  standalone: true,
  imports: [TranslocoModule, MainButtonComponent, CommonModule],
  templateUrl: './require-profile-modal.component.html',
  styleUrl: './require-profile-modal.component.scss',
})
export class RequireProfileModalComponent {
  constructor(
    private store: Store,
    private navigation: NavigationService
  ) {}
  goToProfile() {
    this.closeModal();
    this.navigation.navigateTo('/(aside:account/profile)');
  }
  closeModal() {
    this.store.dispatch(ModalsActions['[modals]CloseModalsSuccess']());
  }
}
